(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-collection-cards"] && !Shopify.designMode) return;
  try {
    
  function setupMegaCollectionCards() {
    document.querySelectorAll('.mega-collection-cards__rail-wrap').forEach(function(wrap) {
      if (wrap.dataset.megaCollectionCardsReady === 'true') return;
      var rail = wrap.querySelector('[data-mega-collection-rail]');
      var prev = wrap.querySelector('[data-mega-collection-prev]');
      var next = wrap.querySelector('[data-mega-collection-next]');
      if (!rail || !prev || !next) return;
      function scrollCards(direction) {
        var card = rail.querySelector('.mega-collection-cards__card');
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 24;
        var amount = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
      prev.addEventListener('click', function(event) {
        event.preventDefault();
        scrollCards(-1);
      });
      next.addEventListener('click', function(event) {
        event.preventDefault();
        scrollCards(1);
      });
      wrap.dataset.megaCollectionCardsReady = 'true';
    });
  }

  setupMegaCollectionCards();
  document.addEventListener('shopify:section:load', setupMegaCollectionCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-dual-product-lists"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mega-curated-carousel')) {
    customElements.define(
      'mega-curated-carousel',
      class MegaCuratedCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.carouselReady === 'true') return;
          this.dataset.carouselReady = 'true';

          const viewport = this.querySelector('[data-carousel-viewport]');
          const pages = Array.from(this.querySelectorAll('.mega-curated-carousel__page'));
          const previousButton = this.querySelector('[data-carousel-prev]');
          const nextButton = this.querySelector('[data-carousel-next]');
          const status = this.querySelector('[data-carousel-status]');

          if (!viewport || pages.length < 2 || !previousButton || !nextButton || !status) return;

          let currentPage = 0;
          let scheduledFrame = 0;

          const update = () => {
            const pageWidth = Math.max(viewport.clientWidth, 1);
            currentPage = Math.max(0, Math.min(pages.length - 1, Math.round(viewport.scrollLeft / pageWidth)));
            previousButton.disabled = currentPage === 0;
            nextButton.disabled = currentPage === pages.length - 1;
            status.textContent = `${currentPage + 1} / ${pages.length}`;
          };

          const goToPage = (pageIndex) => {
            const safePage = Math.max(0, Math.min(pages.length - 1, pageIndex));
            viewport.scrollTo({
              left: safePage * viewport.clientWidth,
              behavior: 'smooth',
            });
          };

          previousButton.addEventListener('click', () => goToPage(currentPage - 1));
          nextButton.addEventListener('click', () => goToPage(currentPage + 1));
          viewport.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(scheduledFrame);
              scheduledFrame = requestAnimationFrame(update);
            },
            { passive: true },
          );

          if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(update);
            observer.observe(viewport);
          }

          update();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
